import React from 'react';
import { Checkbox, Typography, theme } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import SeverityPicker from 'components/mantenciones/SeverityPicker';
import ComponentTreeSelect from 'pages/liftlogic/v2/Components/ComponentTreeSelect';

const TIPOS = [
  { value: 'INCIDENCIA', label: 'Problema' },
  { value: 'SUGERENCIA', label: 'Recomendación' },
];
const labelStyle = { fontSize: 12, fontWeight: 600, display: 'block', marginBottom: 6 };

function HallazgoFields({
  value = {},
  onChange,
  equipoId,
  show = {},
  ascensorOptions = [],
  fotos = null,
  sugeridoComp = null,
  descripcionLabel,
}) {
  const emit = (patch) => onChange?.(patch);
  const isSug = value.tipo === 'SUGERENCIA';
  const dLabel = descripcionLabel || (isSug ? 'Recomendación' : 'Descripción del problema');

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      {show.tipo && (
        <div>
          <label style={labelStyle} htmlFor="hf-tipo">
            Tipo
          </label>
          <select
            id="hf-tipo"
            aria-label="Tipo"
            value={value.tipo}
            onChange={(e) => emit({ tipo: e.target.value })}
            style={{ width: '100%', padding: 6 }}
          >
            {TIPOS.map((t) => (
              <option key={t.value} value={t.value}>
                {t.label}
              </option>
            ))}
          </select>
        </div>
      )}
      {show.ascensor && (
        <div>
          <label style={labelStyle} htmlFor="hf-asc">
            Ascensor
          </label>
          <select
            id="hf-asc"
            aria-label="Ascensor"
            value={value.idAscensor ?? ''}
            onChange={(e) => emit({ idAscensor: e.target.value ? Number(e.target.value) : null })}
            disabled={ascensorOptions.length <= 1}
            style={{ width: '100%', padding: 6 }}
          >
            <option value="">{ascensorOptions.length === 0 ? 'Sin equipos' : 'Seleccionar'}</option>
            {ascensorOptions.map((o) => (
              <option key={o.value} value={o.value}>
                {o.label}
              </option>
            ))}
          </select>
        </div>
      )}
      {show.descripcion !== false && (
        <div>
          <label style={labelStyle} htmlFor="hf-desc">
            {dLabel}
          </label>
          <TextArea
            id="hf-desc"
            value={value.descripcion || ''}
            onChange={(e) => emit({ descripcion: e.target.value })}
            rows={3}
            placeholder="Describe el hallazgo…"
          />
        </div>
      )}
      {show.severidad && !isSug && (
        <div>
          <label style={labelStyle}>Severidad</label>
          <SeverityPicker value={value.severidad} onPick={(v) => emit({ severidad: v })} />
        </div>
      )}
      {show.componente && (
        <div>
          <label style={labelStyle}>Componente afectado (opcional)</label>
          <ComponentTreeSelect
            equipoId={equipoId}
            value={value.idComponente ?? undefined}
            onChange={(v) => emit({ idComponente: v ?? null })}
            placeholder="Asociar a un componente del equipo"
          />
          {sugeridoComp && value.idComponente === sugeridoComp.id ? (
            <Typography.Text type="secondary" style={{ fontSize: 11, fontStyle: 'italic' }}>
              Sugerido por la actividad ({sugeridoComp.name}) — podés cambiarlo o quitarlo.
            </Typography.Text>
          ) : null}
        </div>
      )}
      {show.mostrarEnComprobante && (
        <Checkbox
          checked={value.mostrarEnComprobante !== false}
          onChange={(e) => emit({ mostrarEnComprobante: e.target.checked })}
        >
          <Typography.Text style={{ fontSize: 12 }}>Incluir en el comprobante</Typography.Text>
        </Checkbox>
      )}
      {fotos}
    </div>
  );
}

export default HallazgoFields;
